import React from 'react';
import ErrorPage from './ErrorPage';
import { BodyText, FATAL_ERROR_NOTICE_TYPES } from '@kallidus/common';
import { Trans, useTranslation } from 'react-i18next';
import InlineTextLink from '@Generic/InlineTextLink/InlineTextLink';
import { KALLIDUS_STATUS_PAGE_URL } from '@ApplicationWide/constants/external_urls';

const RUBRIC_COMPONENTS = {
  StatusPageLink: <InlineTextLink href={KALLIDUS_STATUS_PAGE_URL} />,
};

export default function MaintenanceErrorPage() {
  const { t } = useTranslation();
  return (
    <ErrorPage title={t('maintenance.title')} type={FATAL_ERROR_NOTICE_TYPES.MAINTENANCE}>
      <BodyText>
        <Trans i18nKey='maintenance.rubric' components={RUBRIC_COMPONENTS} />
      </BodyText>
    </ErrorPage>
  );
}
